/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthCenterDto } from '../../models/growth-center-dto';

export interface GrowthCenterControllerFindById$Params {
  id: string;
}

export function growthCenterControllerFindById(http: HttpClient, rootUrl: string, params: GrowthCenterControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthCenterDto>> {
  const rb = new RequestBuilder(rootUrl, growthCenterControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrowthCenterDto>;
    })
  );
}

growthCenterControllerFindById.PATH = '/api/growth-center/{id}';
